import { render, staticRenderFns } from "./Proteccion.vue?vue&type=template&id=0cfb88a6&"
import script from "./Proteccion.vue?vue&type=script&lang=js&"
export * from "./Proteccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports